export const AUTH_TOKEN_KEY = 'authToken';
export const AUTH_ROLE_KEY = 'authRole';
export const AUTH_USERNAME_KEY = 'authUsername';
export const AUTH_APP_MODE_KEY = 'authAppMode';
